<template>
  <div class="l_collect_stamp_faq">
    <div class="container">
      <div class="content">
        <h3>スタンプをためるには</h3>
        <hr />
        <p>
          各種設定を有効にして（※）、お店のレジ周辺にお立ち寄りいただくことで、来店スタンプをゲットできます。<br />スタンプは最大1日2回、2回目のスタンプは1回目のスタンプ獲得から6時間を経過した来店で獲得可能です。（日を跨いだ場合も、前回のスタンプ獲得から6時間以上経過の場合に獲得可能です。)
        </p>
        <img :src="require('@/assets/img/faq/get_stamp.png')" />
        <h4>※ 各種設定を有効にする方法</h4>
        <p>
          [ヘルプ・お問い合わせ] ＞ [基本設定]からアプリ設定をお願いします。
        </p>
        <div class="l_button__external">
          <UIButton :label="'いますぐアプリ設定する'" @click="tapLinkSetting" />
        </div>
        <div class="l_button__external">
          <UIButton
            :label="'スタンプがもらえない時は？'"
            @click="tapLinkStamp"
          />
        </div>
        <br />
        <br />
        <h3>スタンプをためると</h3>
        <hr />
        <p>
          来店スタンプが５個または10個たまるたびに、ポテトフライやジョイカフェ無料クーポンなど様々な特典をプレゼント！
        </p>
        <img :src="require('@/assets/img/faq/5or10.png')" />
        <br />
        <br />
        <h3>スタンプをためてランクアップ！</h3>
        <hr />
        <p>
          スタンプをたくさんためると、カードのランクが上がります。ランクが上がると優待特典が！
        </p>
        <img :src="require('@/assets/img/faq/rankup.png')" />
        <div class="caption">
          ※ダイヤモンドランク達成後は、ボーナスランクとなります。
        </div>
        <div class="l_button__external">
          <UIButton :label="'各ランクの特典を見る'" @click="tapLinkPrize" />
        </div>
        <br />
        <br />
        <h3>スタンプカードリセットについて</h3>
        <hr />
        <p>詳細は下記ボタンからご確認ください。<br /></p>
        <div class="l_button__external">
          <UIButton
            :label="'スタンプカードリセットについて'"
            @click="tapLinkReset"
          />
        </div>
        <br />
        <br />
        <h3>月間ランキング</h3>
        <hr />
        <p>
          前月末の直近２ヶ月のスタンプ数で、毎月ランキングを発表します。<br />
          <img :src="require('@/assets/img/faq/link_monthlyrank.png')" /><br />

          「これまでの月間ランキング＞」で、最大１２ヶ月分の月間ランキングが表示されます<br />
          <img :src="require('@/assets/img/faq/past_ranking.png')" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import '@/styles/color.css'

export default {
  name: 'FAQCollectStamp',
  components: {
    UIButton
  },
  created() {
    document.title = 'スタンプをためよう'
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo']),
    ...mapActions('Analytics', ['trackEvent']),
    tapLinkSetting() {
      this.trackEvent(FactoryTrack.createSettingApp())
      this.actionNavigateTo('1')
    },
    tapLinkStamp() {
      this.trackEvent(FactoryTrack.createFAQStamp())
      this.$router.push({
        name: 'FAQStamp'
      })
    },
    tapLinkPrize() {
      this.trackEvent(FactoryTrack.createPrizes())
      this.$router.push({
        name: 'Prizes'
      })
    },
    tapLinkReset() {
      this.trackEvent(FactoryTrack.createPrizes())
      this.$router.push({
        name: 'ResetStampFAQ'
      })
    }
  }
}
</script>
import '@/styles/color.css'

<style lang="scss" scoped>
.l_collect_stamp_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_collect_stamp_faq h3,
.l_collect_stamp_faq h4 {
  color: var(--accent-color);
}

.l_collect_stamp_faq h4 {
  margin: 10px 0px;
}

.l_collect_stamp_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_collect_stamp_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;

  .caption {
    text-align: left;
    width: 100%;

    &.right {
      text-align: right;
    }

    font-size: 12px;
    color: rgb(102, 102, 102);
  }
}

.l_collect_stamp_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}

.l_collect_stamp_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}
</style>
